// extracted by mini-css-extract-plugin
export var go = "Search-module--go--6IJsu";
export var icon = "Search-module--icon--C1D+j";
export var input = "Search-module--input--Dfe9o";
export var root = "Search-module--root--88jZX";
export var searchbar = "Search-module--searchbar--K2xDF";